import { useEffect, useState } from "react";

// Msal imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionStatus, InteractionType, InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

// Sample app imports
import { DirectoryData } from "../ui-components/DirectoryData";
import { Loading } from "../ui-components/Loading";
import { ErrorComponent } from "../ui-components/ErrorComponent";
import { callMsGraph } from "../utils/MsGraphApiCall";
import { graphConfig } from "../authConfig";

const DirectoryContent = () => {
    const { instance, inProgress } = useMsal();
    const [ directoryData, setDirectoryData] = useState(null);

    useEffect(() => {
        if (!directoryData && inProgress === InteractionStatus.None) {
            callMsGraph(graphConfig.graphUsersEndpoint).then(setDirectoryData).catch((e) => {
                if (e instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect({
                        ...loginRequest,
                        account: instance.getActiveAccount()
                    });
                }
            });
        }
    }, [inProgress, directoryData, instance]);

    return (
        <div style={{ height: '100%', width: '100%' }}>
            { directoryData ? <DirectoryData directoryData={directoryData} /> : null }    
        </div>
    );
};

export function Directory() {
    const authRequest = {
        ...loginRequest
    };

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={authRequest}
            errorComponent={ErrorComponent}
            loadingComponent={Loading}
            style={{display: 'flex'}}
        >
            <DirectoryContent />
        </MsalAuthenticationTemplate>
    )
};